import { render, staticRenderFns } from "./SendStreetLightTicketForm.vue?vue&type=template&id=58456c3f&scoped=true"
import script from "./SendStreetLightTicketForm.vue?vue&type=script&lang=ts"
export * from "./SendStreetLightTicketForm.vue?vue&type=script&lang=ts"
import style0 from "./SendStreetLightTicketForm.vue?vue&type=style&index=0&id=58456c3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58456c3f",
  null
  
)

export default component.exports